import LegalDocument from './LegalDocument';
import { REFUND_POLICY, REFUND_POLICY_VERSION } from './refundPolicyContent';

/** 세미나 참가비 결제·취소·환불 정책 페이지 (footer /refund-policy). PG 심사용 환불 정책 URL. */
const RefundPolicy = () => {
    return (
        <LegalDocument
            title="세미나 결제·취소·환불 정책"
            version={REFUND_POLICY_VERSION}
            content={REFUND_POLICY}
        />
    );
};

export default RefundPolicy;
